const CalendarTab = {
    DAY: 0,
    WEEK: 1,
    MONTH: 2, 
}

export default CalendarTab;